import React from "react";
import { styled } from "styled-components";
import { setCurrentRole } from "../../../../store/userManagement";
import { useDispatch } from "react-redux";
interface RolesProps {
  onRoleChange: (role: { type: string; name: string }) => void;
  roles: { type: string; name: string }[];
}

const UserRoles: React.FC<RolesProps> = ({ onRoleChange, roles }) => {
  return (
    <RolesWrapper>
      {roles.map((role) => (
        <StyledSpan
          key={role.name}
          onClick={(e) => {
            onRoleChange(role);
            e.stopPropagation();
          }}
        >
          {role.name}
        </StyledSpan>
      ))}
    </RolesWrapper>
  );
};

export default UserRoles;

export const RolesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 110%;
  left: 0;
  background: #fff;
  box-shadow: 0px 8;
  border: 1px solid #e8eaed;
  border-radius: 0.5rem;
  @media screen and (max-width: 767px) {
  }
`;

export const StyledSpan = styled.span`
  padding: 0.625rem 1.5rem;
  border-bottom: 1px solid #e8eaed;
  color: #5e5e5e;
  cursor: pointer;
  position: relative;
  background: #fff;
  z-index: 100;
  white-space: nowrap;
  &:hover {
    background-color: #ebebeb;
  }
`;
